import { mapGetters } from 'vuex'

export default {
  install (Vue) {
    Vue.mixin({
      computed: {
        // mix the getters into computed with object spread operator
        ...mapGetters([
          'getNavBarState',
          'getScrollDirection'
        ])
      }
    })
  }
}
